import { createSlice } from '@reduxjs/toolkit';

import { buildConsumerSession, emptyConsumerSession } from './consumerSession';

const toConfirmedFlag = (payload) => {
  if (typeof payload === 'object' && payload !== null) {
    return Boolean(payload.confirmed);
  }

  return Boolean(payload);
};

const initialState = {
  isConfirmed: false,
  session: { ...emptyConsumerSession },
};

const consumerSlice = createSlice({
  name: 'consumer',
  initialState,
  reducers: {
    resetConsumerData: () => initialState,
    changeConfirmed: (state, action) => {
      const confirmed = toConfirmedFlag(action.payload);
      state.isConfirmed = confirmed;

      if (!confirmed) {
        state.session = { ...emptyConsumerSession };
      }
    },
    setConsumerSession: (state, action) => {
      state.isConfirmed = true;
      state.session = buildConsumerSession(action.payload);
    },
    clearConsumerSession: (state) => {
      state.isConfirmed = false;
      state.session = { ...emptyConsumerSession };
    },
  },
});

export const { resetConsumerData, changeConfirmed, setConsumerSession, clearConsumerSession } = consumerSlice.actions;

export default consumerSlice.reducer;
